import { Badge, createTheme } from 'flowbite-react';
import { FC, PropsWithChildren, SVGProps } from 'react';
import { getReplaceThemeProps } from 'utils/replaceTheme';

export type StatusBadgeSize = 'sm' | 'md' | 'lg';

export const theme = createTheme({
    badge: {
        root: {
            base: 'flex items-center lowercase gap-1 !p-px !pl-0.5 !pr-2 font-medium border',
            color: {
                green: 'border-green-400 bg-green-100 text-green-800',
                yellow: 'border-yellow-400 bg-yellow-100 text-yellow-800',
                red: 'border-red-400 bg-red-100 text-red-800',
                purple: 'border-purple-400 bg-purple-100 text-purple-800',
                blue: 'border-blue-400 bg-blue-100 text-blue-800',
            },
            size: {
                sm: 'p-1 text-xs',
                md: 'p-1.5 text-xs',
                lg: 'p-1.5 text-sm',
            },
        },
        icon: {
            size: {
                sm: 'h-2 w-2',
                md: 'h-4 w-4',
                lg: 'h-6 w-6',
            },
        },
    },
}).badge;

interface StatusBadgeProps extends PropsWithChildren {
    color: string;
    Icon: FC<SVGProps<SVGSVGElement>>;
    size?: StatusBadgeSize;
}

export const StatusBadge = ({
    color,
    Icon,
    size = 'md',
    children,
}: StatusBadgeProps) => (
    <Badge
        {...getReplaceThemeProps(theme)}
        color={color}
        size={size}
        icon={Icon}
    >
        {children}
    </Badge>
);
